import { Code, Link } from '@do/walrus';
import * as React from 'react';

import { getAddonSlug, getImageLabel, getName } from '../../selectors';
import { isDroplet, isKubernetes } from '../../utils';

interface Props {
  app: any;
}

const ApiCreationSection: React.FC<Props> = ({ app }) => {
  const imageLabel = getImageLabel(app);
  if (isDroplet(app) && imageLabel) {
    return (
      <>
        <h2>API Creation</h2>
        <p>
          In addition to creating a Droplet from the {app.name} 1-Click App via
          the control panel, you can also use the{' '}
          <Link to="https://digitalocean.com/docs/api" type="external">
            DigitalOcean API
          </Link>
          .
        </p>
        <p>
          As an example, to create a 4GB {app.name} Droplet in the NYC3 region,
          you can use the following curl command. You’ll need to either save
          your{' '}
          <Link
            to="https://docs.digitalocean.com/reference/api/create-personal-access-token/"
            type="external"
          >
            API access token
          </Link>{' '}
          to an environment variable or substitute it into the command below.
        </p>
        <div>
          <Code language="shell">
            {`
  curl -X POST -H 'Content-Type: application/json' \\
       -H 'Authorization: Bearer '$TOKEN'' -d \\
      '{"name":"choose_a_name","region":"nyc3","size":"s-2vcpu-4gb","image":"${imageLabel}"}' \\
      "https://api.digitalocean.com/v2/droplets"
      `}
          </Code>
        </div>
      </>
    );
  }

  if (isKubernetes(app)) {
    return (
      <>
        <h2>API Creation</h2>
        <p>
          In addition to creating {getName(app)} via the control panel, you can
          also use the{' '}
          <Link
            to="https://developers.digitalocean.com/documentation/v2/#create-a-new-kubernetes-cluster"
            type="external"
          >
            DigitalOcean API
          </Link>
          .
        </p>
        <p>
          As an example, to create a 3 node DigitalOcean Kubernetes cluster made
          up of Basic Droplets in the NYC3 region, you can use the following
          doctl command. You'll need to authenticate with doctl with your{' '}
          <Link
            to="https://docs.digitalocean.com/reference/api/create-personal-access-token/"
            type="external"
          >
            API access token
          </Link>{' '}
          , and replace the $CLUSTER_NAME variable with the chosen name for your
          cluster in the command below.
        </p>
        <div>
          <Code language="shell">
            {`
              doctl kubernetes clusters create --size s-4vcpu-8gb $CLUSTER_NAME --1-clicks ${
                getAddonSlug(app) || '$slug'
              }
            `}
          </Code>
        </div>
      </>
    );
  }

  return null;
};

export default ApiCreationSection;
